// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Data types
import {
  upholsteryCore,
  upholsteryListing
} from '../../../data-types/upholstery';

// This component
export default function Upholstery() {
  // Data types
  const { endpoint } = upholsteryCore();
  const {
    initialSort,
    initialFilters,
    getColumns,
    getRows,
    getFilters
  } = upholsteryListing();

  // Listing
  const {
    activeFilters,
    saveActiveFilters,
    page,
    pageSize,
    setPage,
    setPageSize,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'data-type',
        // Static
        initialFilters,
        endpoint,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        activeFilters,
        saveActiveFilters,
        page,
        pageSize,
        setPage,
        setPageSize,
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Upholsteries"
        buttonNewLabel="New Upholstery"
        buttonNewUrl="/upholstery/new"
        exportAction={true}
        buttonExportLabel="Export Data"
      />
    </ListingContext.Provider>
  );
}
